import React, { useRef, useState, useEffect } from "react";
import { PDFDocument } from "pdf-lib";
import {
  compressedFileSize,
  convertPdfArrayBuffer,
  getBase64FromUrl,
  getContainerScale,
  multiSignEmbed,
  onSaveImage,
  onSaveSign,
  pdfNewWidthFun,
  placeholderWidth,
  placeholderHeight,
  randomId,
} from "../utils/general";
import RenderPdf from "../components/document/RenderPdf";
import RenderAllPdfPage from "../components/document/RenderAllPdfPage";
import SignPad from "../components/document/SignPad";
import DatePickerModal from "../components/document/DatePickerModal";
import PrevNext from "../components/document/PrevNext";
import { useLoading } from "../contexts/LoadingContext";
import toast from "react-hot-toast";
import { useAuth } from "../contexts/AuthContext";

const SelfSignDocument = ({
  templateData = null,
  onSave = () => {},
  defaultInitials = null,
  defaultSignature = null,
}) => {
  const divRef = useRef(null);
  const [pdfBase64Url, setPdfBase64Url] = useState(null);
  const [pdfArrayBuffer, setPdfArrayBuffer] = useState(null);
  const [allPages, setAllPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [containerWH, setContainerWH] = useState();
  const [pdfNewWidth, setPdfNewWidth] = useState();
  const [pdfOriginalWH, setPdfOriginalWH] = useState([]);
  const [pdfLoad, setPdfLoad] = useState(false);
  const [scale, setScale] = useState(1);
  const [signerPos, setSignerPos] = useState([]);
  const [signerObjectId, setSignerObjectId] = useState("self");
  const [signedSigners, setSignedSigners] = useState([]);
  const [isSignPad, setIsSignPad] = useState(false);
  const [isStamp, setIsStamp] = useState(false);
  const [signKey, setSignKey] = useState(null);
  const [isInitial, setIsInitial] = useState(false);
  const [validateAlert, setValidateAlert] = useState(false);
  const [unSignedWidgetId, setUnSignedWidgetId] = useState();
  const [selectWidgetId, setSelectWidgetId] = useState();
  const [currWidgetsDetails, setCurrWidgetsDetails] = useState([]);
  const [isResize, setIsResize] = useState(false);
  const [uniqueId, setUniqueId] = useState("self");
  const [isAgree, setIsAgree] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [dragKey, setDragKey] = useState();
  const [isTextSetting, setIsTextSetting] = useState(false);
  const [widgetType, setWidgetType] = useState("");
  const [assignedWidgetId, setAssignedWidgetId] = useState("");
  const [requestSignTour, setRequestSignTour] = useState(false);
  const [zIndex, setZIndex] = useState(1);
  const [fontSize, setFontSize] = useState(12);
  const [fontColor, setFontColor] = useState("black");
  const [signBtnPosition, setSignBtnPosition] = useState([]);
  const [saveSignCheckbox, setSaveSignCheckbox] = useState({
    isVisible: false,
    signId: "",
  });
  const [signatureType, setSignatureType] = useState([
    { name: "draw", enabled: true },
    { name: "typed", enabled: true },
  ]);
  const [isImageSelect, setIsImageSelect] = useState(false);
  const [image, setImage] = useState(null);
  const imageRef = useRef(null);
  const [signature, setSignature] = useState(defaultSignature);
  const [defaultSignImg, setDefaultSignImg] = useState(null);
  const [myInitial, setMyInitial] = useState(defaultInitials);
  const [isAutoSign, setIsAutoSign] = useState(false);
  const [imgWH, setImgWH] = useState({});
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [xySignature, setXYSignature] = useState({});
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [dateModalData, setDateModalData] = useState({
    selectedDate: null,
    onDateChange: null,
    dateFormat: "mm/dd/yyyy",
    fontSize: "14px",
    fontColor: "black",
    allowPastDates: false,
  });
  const { showLoader, hideLoader } = useLoading();

  const openDateModal = (
    selectedDate,
    onDateChange,
    dateFormat,
    fontSize,
    fontColor,
    allowPastDates = false,
  ) => {
    setDateModalData({
      selectedDate,
      onDateChange,
      dateFormat: dateFormat || "mm/dd/yyyy",
      fontSize: fontSize || "14px",
      fontColor: fontColor || "black",
      allowPastDates: allowPastDates || false,
    });
    setIsDateModalOpen(true);
  };

  const closeDateModal = () => {
    setIsDateModalOpen(false);
  };

  // Initialize PDF data
  useEffect(() => {
    const initializePdf = async () => {
      if (templateData?.documentId?.filePath) {
        try {
          const arrayBuffer = await convertPdfArrayBuffer(
            `${
              process.env.REACT_APP_FILE_URL
            }/${templateData.documentId.filePath.replace(/\\/g, "/")}`
          );
          const base64Pdf = await getBase64FromUrl(
            `${
              process.env.REACT_APP_FILE_URL
            }/${templateData.documentId.filePath.replace(/\\/g, "/")}`
          );

          if (arrayBuffer === "Error") {
            toast.error("Something went wrong loading PDF");
          } else {
            setPdfBase64Url(base64Pdf);
            setPdfArrayBuffer(arrayBuffer);

            // const selfSigner = {
            //     Id: "self",
            //     signerObjId: "self",
            //     role: "Self",
            //     name: "Self",
            //     email: "self@example.com",
            //     placeHolder: templateData.recipients[0]?.placeHolder || [],
            //   };
            //   // console.log(selfSigner, "selfSigner");
            // setSignerPos(templateData.recipients);
          }
        } catch (error) {
          console.error("Error loading PDF:", error);
          toast.error("Failed to load PDF");
        }
      }
    };

    initializePdf();
  }, [templateData]);

  const processPlaceHolderToAppendDefaultData = (placeHolder) => {
    return placeHolder.map((item) => {
      return {
        ...item,
        pos: item.pos.map((pos) => {
          if (pos.type === "signature") {
            return {
              ...pos,
              SignUrl: defaultSignature || "",
              options: {
                ...pos.options,
                response: defaultSignature || "",
              },
            };
          }
          if (pos.type === "initials") {
            return {
              ...pos,
              SignUrl: defaultInitials || "",
              options: {
                ...pos.options,
                response: defaultInitials || "",
              },
            };
          }
          return pos;
        }),
      };
    });
  };

  console.log("myInitial", signerPos);

  // Initialize signer data
  useEffect(() => {
    if (templateData?.recipients) {
      const selfSigner = {
        Id: "self",
        signerObjId: "self",
        role: "Self",
        name: "Self",
        email: "self@example.com",
        placeHolder: processPlaceHolderToAppendDefaultData(
          templateData.recipients[0]?.placeHolder || []
        ),
      };
      console.log("selfSigner", selfSigner);
      setSignerPos([selfSigner]);
    }
  }, [templateData]);

  // Update container size
  useEffect(() => {
    const updateSize = () => {
      if (divRef.current) {
        const pdfWidth = pdfNewWidthFun(divRef);
        setPdfNewWidth(pdfWidth);
        setContainerWH({
          width: divRef.current.offsetWidth,
          height: divRef.current.offsetHeight,
        });
        setScale(1);
      }
    };

    const timer = setTimeout(updateSize, 100);
    return () => clearTimeout(timer);
  }, [divRef.current]);

  const pageDetails = async (pdf) => {
    let pdfWHObj = [];
    const totalPages = pdf?.numPages;
    for (let index = 0; index < totalPages; index++) {
      const getPage = await pdf.getPage(index + 1);
      const scale = 1;
      const { width, height } = getPage.getViewport({ scale });
      pdfWHObj.push({ pageNumber: index + 1, width, height });
    }
    setPdfOriginalWH(pdfWHObj);
    setPdfLoad(true);
  };

  const handleTabDrag = (key) => {
    setDragKey(key);
    setIsDragging(true);
  };

  const handleStop = (event, dragElement, signerId, key) => {
    if (!isResize && isDragging) {
      let updateSignPos = [...signerPos];
      const signerObjId = signerId ? signerId : uniqueId;
      const keyValue = key ? key : dragKey;
      const containerScale = getContainerScale(
        pdfOriginalWH,
        pageNumber,
        containerWH
      );

      const filterSignerPos = updateSignPos.filter(
        (data) => data.Id === signerObjId
      );
      if (filterSignerPos.length > 0) {
        const getPlaceHolder = filterSignerPos[0].placeHolder;
        const getPageNumer = getPlaceHolder.filter(
          (data) => data.pageNumber === pageNumber
        );
        if (getPageNumer.length > 0) {
          const getXYdata = getPageNumer[0].pos;
          const addSignPos = getXYdata.map((url) => {
            if (url.key === keyValue) {
              return {
                ...url,
                xPosition: dragElement.x / (containerScale * scale),
                yPosition: dragElement.y / (containerScale * scale),
              };
            }
            return url;
          });

          const newUpdateSignPos = getPlaceHolder.map((obj) => {
            if (obj.pageNumber === pageNumber) {
              return { ...obj, pos: addSignPos };
            }
            return obj;
          });

          const newUpdateSigner = updateSignPos.map((obj) => {
            if (obj.Id === signerObjId) {
              return { ...obj, placeHolder: newUpdateSignPos };
            }
            return obj;
          });

          setSignerPos(newUpdateSigner);
        }
      }
    }
    setTimeout(() => setIsDragging(false), 200);
  };

  const handleDeleteSign = (key, Id) => {
    const updateData = [];
    const filterSignerPos = signerPos.filter((data) => data.Id === Id);

    if (filterSignerPos.length > 0) {
      const getPlaceHolder = filterSignerPos[0].placeHolder;
      const getPageNumer = getPlaceHolder.filter(
        (data) => data.pageNumber === pageNumber
      );

      if (getPageNumer.length > 0) {
        const getXYdata = getPageNumer[0].pos.filter(
          (data) => data.key !== key
        );

        if (getXYdata.length > 0) {
          updateData.push(getXYdata);
          const newUpdatePos = getPlaceHolder.map((obj) => {
            if (obj.pageNumber === pageNumber) {
              return { ...obj, pos: updateData[0] };
            }
            return obj;
          });

          const newUpdateSigner = signerPos.map((obj) => {
            if (obj.Id === Id) {
              return { ...obj, placeHolder: newUpdatePos };
            }
            return obj;
          });

          setSignerPos(newUpdateSigner);
        } else {
          const getRemainPage = filterSignerPos[0].placeHolder.filter(
            (data) => data.pageNumber !== pageNumber
          );

          if (getRemainPage && getRemainPage.length > 0) {
            const newUpdatePos = filterSignerPos.map((obj) => {
              if (obj.Id === Id) {
                return { ...obj, placeHolder: getRemainPage };
              }
              return obj;
            });
            let signerupdate = [];
            signerupdate = signerPos.filter((data) => data.Id !== Id);
            signerupdate.push(newUpdatePos[0]);
            setSignerPos(signerupdate);
          } else {
            const updatedData = signerPos.map((item) => {
              if (item.Id === Id) {
                const updatedItem = { ...item };
                delete updatedItem.placeHolder;
                return updatedItem;
              }
              return item;
            });
            setSignerPos(updatedData);
          }
        }
      }
    }
  };

  const saveImage = () => {
    const widgetsType = currWidgetsDetails?.type;
    const currentSigner = signerPos.filter(
      (data) => data.signerObjId === signerObjectId
    );
    const getIndex = currentSigner[0].placeHolder.findIndex((object) => {
      return object.pageNumber === pageNumber;
    });
    const placeholderPosition = currentSigner[0].placeHolder;
    const isApplyAll = true;

    const getUpdatePosition = onSaveImage(
      widgetsType,
      placeholderPosition,
      getIndex,
      signKey,
      image,
      imgWH,
      isApplyAll
    );

    const indexofSigner = signerPos.findIndex((object) => {
      return object.signerObjId === signerObjectId;
    });

    setSignerPos((prevState) => {
      const newState = [...prevState];
      newState.splice(indexofSigner, 1, ...getUpdatePosition);
      return newState;
    });

    setIsSignPad(false);
    setIsImageSelect(false);
    setImage();
  };

  const saveSign = (type, isDefaultSign, width, height, typedSignature) => {
    const widgetsType = currWidgetsDetails?.type;
    const isTypeText = width && height ? true : false;
    const signatureImg = isDefaultSign
      ? isDefaultSign === "initials"
        ? myInitial
        : defaultSignImg
      : signature;
    let imgWH = { width: width ? width : "", height: height ? height : "" };
    setIsSignPad(false);
    setIsImageSelect(false);
    setImage();

    const currentSigner = signerPos.filter(
      (data) => data.signerObjId === signerObjectId
    );

    const getIndex = currentSigner[0].placeHolder.findIndex((object) => {
      return object.pageNumber === pageNumber;
    });

    if (isDefaultSign) {
      const img = new Image();
      img.src = defaultSignImg;
      if (img.complete) {
        imgWH = { width: img.width, height: img.height };
      }
    }

    const placeholderPosition = currentSigner[0].placeHolder;
    const isApplyAll = true;

    const getUpdatePosition = onSaveSign(
      type,
      placeholderPosition,
      getIndex,
      signKey,
      signatureImg,
      imgWH,
      isDefaultSign,
      isTypeText,
      typedSignature,
      isAutoSign,
      widgetsType,
      isApplyAll
    );

    const updateSignerData = currentSigner.map((obj) => {
      if (obj.signerObjId === signerObjectId) {
        return { ...obj, placeHolder: getUpdatePosition };
      }
      return obj;
    });

    const index = signerPos.findIndex(
      (data) => data.signerObjId === signerObjectId
    );

    setSignerPos((prevState) => {
      const newState = [...prevState];
      newState.splice(index, 1, ...updateSignerData);
      return newState;
    });

    setIsAutoSign(false);
  };

  const validatePlaceholders = () => {
    const checkUser = signerPos.filter(
      (data) => data.signerObjId === signerObjectId
    );

    if (!checkUser || checkUser.length === 0) {
      return { isValid: false, error: "No signer data found" };
    }

    let checkboxExist,
      requiredRadio,
      showAlert = false,
      widgetKey,
      radioExist,
      requiredCheckbox,
      TourPageNumber;

    for (let i = 0; i < checkUser[0].placeHolder.length; i++) {
      for (let j = 0; j < checkUser[0].placeHolder[i].pos.length; j++) {
        //get current page
        const updatePage = checkUser[0].placeHolder[i]?.pageNumber;
        //checking checkbox type widget
        checkboxExist = checkUser[0].placeHolder[i].pos[j].type === "checkbox";
        //checking radio button type widget
        radioExist = checkUser[0].placeHolder[i].pos[j].type === "radio";
        //condition to check checkbox widget exist or not
        if (checkboxExist) {
          //get all required type checkbox
          requiredCheckbox = checkUser[0].placeHolder[i].pos.filter(
            (position) =>
              !position.options?.isReadOnly && position.type === "checkbox"
          );
          //if required type checkbox data exit then check user checked all checkbox or some checkbox remain to check
          //also validate to minimum and maximum required checkbox
          if (requiredCheckbox && requiredCheckbox.length > 0) {
            for (let i = 0; i < requiredCheckbox.length; i++) {
              //get minimum required count if exit
              const minCount =
                requiredCheckbox[i].options?.validation?.minRequiredCount;
              const parseMin = minCount && parseInt(minCount);
              //get maximum required count if exit
              const maxCount =
                requiredCheckbox[i].options?.validation?.maxRequiredCount;
              const parseMax = maxCount && parseInt(maxCount);
              //in `response` variable is used to get how many checkbox checked by user
              const response = requiredCheckbox[i].options?.response?.length;
              //in `defaultValue` variable is used to get how many checkbox checked by default
              const defaultValue =
                requiredCheckbox[i].options?.defaultValue?.length;
              //condition to check parseMin and parseMax greater than 0 then consider it as a required check box
              if (
                parseMin > 0 &&
                parseMax > 0 &&
                !response &&
                !defaultValue &&
                !showAlert
              ) {
                showAlert = true;
                widgetKey = requiredCheckbox[i].key;
                TourPageNumber = updatePage;
              }
              //else condition to validate minimum required checkbox
              else if (parseMin > 0 && (parseMin > response || !response)) {
                if (!showAlert) {
                  showAlert = true;
                  widgetKey = requiredCheckbox[i].key;
                  TourPageNumber = updatePage;
                }
              }
            }
          }
        }
        //condition to check radio widget exist or not
        else if (radioExist) {
          //get all required type radio button
          requiredRadio = checkUser[0].placeHolder[i].pos.filter(
            (position) =>
              !position.options?.isReadOnly && position.type === "radio"
          );
          //if required type radio data exit then check user checked all radio button or some radio remain to check
          if (requiredRadio && requiredRadio?.length > 0) {
            let checkSigned;
            for (let i = 0; i < requiredRadio?.length; i++) {
              checkSigned = requiredRadio[i]?.options?.response;
              if (!checkSigned) {
                let checkDefaultSigned =
                  requiredRadio[i]?.options?.defaultValue;
                if (!checkDefaultSigned && !showAlert) {
                  showAlert = true;
                  widgetKey = requiredRadio[i].key;
                  TourPageNumber = updatePage;
                }
              }
            }
          }
        }
        //else condition to check all type widget data fill or not except checkbox and radio button
        else {
          //get all required type widgets except checkbox and radio
          const requiredWidgets = checkUser[0].placeHolder[i].pos.filter(
            (position) =>
              position.options?.status === "required" &&
              position.type !== "radio" &&
              position.type !== "checkbox"
          );
          if (requiredWidgets && requiredWidgets?.length > 0) {
            let checkSigned;
            for (let i = 0; i < requiredWidgets?.length; i++) {
              checkSigned = requiredWidgets[i]?.options?.response;
              if (!checkSigned) {
                const checkSignUrl = requiredWidgets[i]?.pos?.SignUrl;
                if (!checkSignUrl) {
                  let checkDefaultSigned =
                    requiredWidgets[i]?.options?.defaultValue;
                  if (!checkDefaultSigned && !showAlert) {
                    showAlert = true;
                    widgetKey = requiredWidgets[i].key;
                    TourPageNumber = updatePage;
                  }
                }
              }

              // Additional validation for Text Input widgets with min/max length constraints
              if (requiredWidgets[i]?.type === "textInput" && checkSigned) {
                const minLength = requiredWidgets[i]?.options?.minLength;
                const maxLength = requiredWidgets[i]?.options?.maxLength;
                const responseLength = checkSigned.length;

                // Validate min length constraint
                if (
                  minLength &&
                  minLength !== "" &&
                  !isNaN(parseInt(minLength)) &&
                  responseLength < parseInt(minLength)
                ) {
                  if (!showAlert) {
                    showAlert = true;
                    widgetKey = requiredWidgets[i].key;
                    TourPageNumber = updatePage;
                    return {
                      isValid: false,
                      error: `Text input must be at least ${minLength} characters long`,
                    };
                  }
                }

                // Validate max length constraint
                if (
                  maxLength &&
                  maxLength !== "" &&
                  !isNaN(parseInt(maxLength)) &&
                  responseLength > parseInt(maxLength)
                ) {
                  if (!showAlert) {
                    showAlert = true;
                    widgetKey = requiredWidgets[i].key;
                    TourPageNumber = updatePage;
                    return {
                      isValid: false,
                      error: `Text input cannot exceed ${maxLength} characters`,
                    };
                  }
                }
              }
            }
          }
        }
      }
      //when showAlert is true then break the loop and show alert to fill required data in widgets
      if (showAlert) {
        break;
      }
    }

    if (showAlert) {
      return { isValid: false, error: "Please fill all required fields" };
    }

    return { isValid: true, error: null };
  };

  const handleConfirmSign = async () => {
    try {
      // Validate required widgets before proceeding
      const validation = validatePlaceholders();
      if (!validation.isValid) {
        toast.error(validation.error);
        return;
      }

      showLoader();
      const checkUser = signerPos.filter(
        (data) => data.signerObjId === signerObjectId
      );

      if (checkUser && checkUser.length > 0) {
        const widgets = checkUser[0].placeHolder;
        const existingPdfBytes = pdfArrayBuffer;

        const pdfDoc = await PDFDocument.load(existingPdfBytes);

        // Embed multi signature in pdf
        const pdfBytes = await multiSignEmbed(widgets, pdfDoc, false, scale);

        if (!pdfBytes?.error) {
          // Call the onSave callback with the final PDF bytes
          onSave({
            pdfBytes: pdfBytes,
            widgets: widgets,
          });
        }
      }
    } catch (err) {
      // console.log("err in embedsign", err);
      toast.error("Something went wrong");
    } finally {
      hideLoader();
    }
  };

  const changePage = (offset) => {
    setSignBtnPosition([]);
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const handleDivClick = (e) => {
    const isTouchEvent = e.type.startsWith("touch");
    const divRect = e.currentTarget.getBoundingClientRect();
    let mouseX, mouseY;
    if (isTouchEvent) {
      const touch = e.touches[0];
      mouseX = touch.clientX - divRect.left;
      mouseY = touch.clientY - divRect.top;
      setSignBtnPosition([{ xPos: mouseX, yPos: mouseY }]);
    } else {
      mouseX = e.clientX - divRect.left;
      mouseY = e.clientY - divRect.top;
      const xyPosition = { xPos: mouseX, yPos: mouseY };
      setXYSignature(xyPosition);
    }
  };

  const handleMouseLeave = () => {
    setSignBtnPosition([xySignature]);
  };

  const handleTextSettingModal = () => {
    setIsTextSetting(!isTextSetting);
  };


  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      // Check if the file is an image
      if (file.type.startsWith("image/")) {
        // Get widget dimensions for image resizing
        let widgetDimensions = null;
        if (currWidgetsDetails && currWidgetsDetails.type === "image") {
          widgetDimensions = {
            width: placeholderWidth(currWidgetsDetails),
            height: placeholderHeight(currWidgetsDetails),
          };
        }
        compressedFileSize(file, setImgWH, setImage, widgetDimensions);
      } else {
        toast.error("Please select an image file");
      }
    }
  };

  return (
    <div className="h-screen overflow-hidden bg-white">
      <div className="flex h-full">
        {/* Left Sidebar - Save Button */}
        <div className="w-[23%] bg-base-100 min-h-screen max-h-screen overflow-y-auto hide-scrollbar bg-slate-100">
          <div className="p-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800">Self Sign</h2>
          </div>

          <div className="flex-1 p-4">
            <button
              onClick={handleConfirmSign}
              className="w-full bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors"
            >
              Save Document
            </button>
          </div>
        </div>

        {/* Main PDF Area */}
        <div className="flex-1 flex">
          {/* PDF Display */}
          <div className="flex-1 flex flex-col">
            <div className="flex-1 p-4 overflow-y-auto">
              <div ref={divRef} className="h-full ">
                {containerWH && pdfBase64Url && (
                  <RenderPdf
                    setIsPageCopy={() => {}}
                    drop={() => {}}
                    pageNumber={pageNumber}
                    pdfOriginalWH={pdfOriginalWH}
                    pdfNewWidth={pdfNewWidth}
                    setIsSignPad={setIsSignPad}
                    setIsStamp={setIsStamp}
                    setSignKey={setSignKey}
                    pdfDetails={templateData}
                    signerPos={signerPos}
                    successEmail={false}
                    pdfUrl={templateData?.documentId?.path || ""}
                    numPages={1}
                    pageDetails={pageDetails}
                    pdfRequest={true}
                    signerObjectId={signerObjectId}
                    signedSigners={signedSigners}
                    setPdfLoad={setPdfLoad}
                    pdfLoad={pdfLoad}
                    setSignerPos={(value) => {
                      setSignerPos(value);
                    }}
                    containerWH={containerWH}
                    setIsInitial={setIsInitial}
                    setValidateAlert={setValidateAlert}
                    unSignedWidgetId={unSignedWidgetId}
                    setSelectWidgetId={setSelectWidgetId}
                    selectWidgetId={selectWidgetId}
                    setCurrWidgetsDetails={setCurrWidgetsDetails}
                    divRef={divRef}
                    setIsResize={setIsResize}
                    isResize={isResize}
                    setScale={setScale}
                    scale={scale}
                    uniqueId={uniqueId}
                    pdfBase64Url={pdfBase64Url}
                    setIsImageSelect={setIsImageSelect}
                    setIsAgreeTour={() => {}}
                    isAgree={isAgree}
                    handleTabDrag={handleTabDrag}
                    handleStop={handleStop}
                    isDragging={isDragging}
                    setShowDropdown={() => {}}
                    setIsRadio={() => {}}
                    setIsCheckbox={() => {}}
                    setIsTextInput={() => {}}
                    handleNameModal={() => {}}
                    setIsSelectId={() => {}}
                    fontSize={fontSize}
                    setFontSize={setFontSize}
                    fontColor={fontColor}
                    setFontColor={setFontColor}
                    setTempSignerId={() => {}}
                    isAlllowModify={false}
                    setUniqueId={setUniqueId}
                    handleDeleteSign={handleDeleteSign}
                    handleTextSettingModal={handleTextSettingModal}
                    setWidgetType={setWidgetType}
                    assignedWidgetId={assignedWidgetId}
                    setRequestSignTour={setRequestSignTour}
                    openDateModal={openDateModal}
                    isSelfSign={true}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Right Sidebar - Pages */}
          <div className="w-80 bg-white border-l border-gray-200">
            <div className="flex-1 overflow-y-auto">
              <RenderAllPdfPage
                allPages={allPages}
                setAllPages={setAllPages}
                signerPos={signerPos}
                setPageNumber={setPageNumber}
                setSignBtnPosition={setSignBtnPosition}
                pageNumber={pageNumber}
                pdfBase64Url={pdfBase64Url}
                signedUrl={templateData?.documentId?.path || ""}
                setPdfArrayBuffer={setPdfArrayBuffer}
                setPdfBase64Url={setPdfBase64Url}
                setIsUploadPdf={() => {}}
                pdfArrayBuffer={pdfArrayBuffer}
                isMergePdfBtn={false}
                changePage={changePage}
                from=""
              />
            </div>
          </div>
        </div>
      </div>

      {/* SignPad Modal */}
      {isSignPad && (
        <SignPad
          saveSignCheckbox={saveSignCheckbox}
          setSaveSignCheckbox={setSaveSignCheckbox}
          signatureTypes={signatureType}
          isSignPad={isSignPad}
          isStamp={isStamp}
          setIsImageSelect={setIsImageSelect}
          setIsSignPad={setIsSignPad}
          setImage={setImage}
          isImageSelect={isImageSelect}
          imageRef={imageRef}
          onImageChange={onImageChange}
          setSignature={setSignature}
          image={image}
          onSaveImage={saveImage}
          onSaveSign={saveSign}
          defaultSign={defaultSignImg}
          myInitial={myInitial}
          setDefaultSignImg={setDefaultSignImg}
          setMyInitial={setMyInitial}
          isInitial={isInitial}
          setIsInitial={setIsInitial}
          setIsStamp={setIsStamp}
          currWidgetsDetails={currWidgetsDetails}
          setCurrWidgetsDetails={setCurrWidgetsDetails}
          setIsAutoSign={setIsAutoSign}
          isAutoSign={isAutoSign}
          userDetails={
            signerPos?.find((item) => item.contactId === "self") || null
          }
        />
      )}

      {/* Date Picker Modal */}
      <DatePickerModal
        isOpen={isDateModalOpen}
        onClose={closeDateModal}
        selectedDate={dateModalData.selectedDate}
        onDateChange={dateModalData.onDateChange}
        dateFormat={dateModalData.dateFormat}
        fontSize={dateModalData.fontSize}
        fontColor={dateModalData.fontColor}
        allowPastDates={dateModalData.allowPastDates}
      />
    </div>
  );
};

export default SelfSignDocument;
